import { render, staticRenderFns } from "./equitiesDetails.vue?vue&type=template&id=73c14158&scoped=true&"
import script from "./equitiesDetails.vue?vue&type=script&lang=js&"
export * from "./equitiesDetails.vue?vue&type=script&lang=js&"
import style0 from "./equitiesDetails.vue?vue&type=style&index=0&id=73c14158&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c14158",
  null
  
)

export default component.exports